import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import Header from './components/Header/Header';
import Chatbot from '../../shared/components/Chatbot/Chatbot';
import './DashboardLayout.css';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const location = useLocation();

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <Header />
      <div className="dashboard-content" key={location.pathname}>
        {children}
      </div>
      <Chatbot />
    </div>
  );
};

export default DashboardLayout;

